"use client";

import { c as _c } from "react/compiler-runtime";
import { publicEnv } from "@/config/env";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import { FC, useContext, useEffect, useMemo, useState } from "react";
import { createPortal } from "react-dom";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { ApiDropType } from "@/generated/models/ApiDropType";
import { DropSize, ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { AuthContext } from "@/components/auth/Auth";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import WaveDropActionsAddReaction from "./WaveDropActionsAddReaction";
import WaveDropActionsRate from "./WaveDropActionsRate";
import WaveDropMobileMenuDelete from "./WaveDropMobileMenuDelete";
import WaveDropMobileMenuEdit from "./WaveDropMobileMenuEdit";
import WaveDropMobileMenuFollow from "./WaveDropMobileMenuFollow";
import WaveDropMobileMenuOpen from "./WaveDropMobileMenuOpen";
interface WaveDropMobileMenuProps {
  readonly drop: ApiDrop;
  readonly isOpen: boolean;
  readonly showReplyAndQuote: boolean;
  readonly longPressTriggered: boolean;
  readonly setOpen: (open: boolean) => void;
  readonly onReply: () => void;
  readonly onQuote: () => void;
  readonly onAddReaction: () => void;
  readonly onEdit?: () => void;
  readonly showOpenOption?: boolean;
  readonly showCopyOption?: boolean;
  readonly showFollowOption?: boolean;
}
const WaveDropMobileMenu: FC<WaveDropMobileMenuProps> = t0 => {
  const $ = _c(79);
  const {
    drop,
    isOpen,
    showReplyAndQuote,
    longPressTriggered,
    setOpen,
    onReply,
    onQuote,
    onAddReaction,
    onEdit,
    showOpenOption: t1,
    showCopyOption: t2,
    showFollowOption: t3
  } = t0;
  const showOpenOption = t1 === undefined ? true : t1;
  const showCopyOption = t2 === undefined ? true : t2;
  const showFollowOption = t3 === undefined ? true : t3;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  let t4;
  if ($[0] !== drop.id) {
    t4 = drop.id.startsWith("temp-");
    $[0] = drop.id;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const isTemporaryDrop = t4;
  let t5;
  if ($[2] !== drop) {
    t5 = {
      ...drop,
      type: DropSize.FULL,
      stableKey: drop.id,
      stableHash: drop.id
    };
    $[2] = drop;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const extendedDrop = t5;
  const [copied, setCopied] = useState(false);
  let t6;
  if ($[4] !== drop.serial_no || $[5] !== drop.wave || $[6] !== isTemporaryDrop || $[7] !== longPressTriggered) {
    t6 = () => {
      if (longPressTriggered) {
        return;
      }
      if (isTemporaryDrop) {
        return;
      }
      const waveDetails = drop.wave as unknown as {
        chat?: {
          scope?: {
            group?: {
              is_direct_message?: boolean;
            };
          };
        };
      } ?? undefined;
      const isDirectMessage = waveDetails?.chat?.scope?.group?.is_direct_message ?? false;
      const dropLink = `${publicEnv.BASE_ENDPOINT}${getWaveRoute({
        waveId: drop.wave.id,
        serialNo: drop.serial_no,
        isDirectMessage,
        isApp: false
      })}`;
      if (navigator?.clipboard?.writeText) {
        navigator.clipboard.writeText(dropLink).then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        });
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = dropLink;
        textArea.style.position = "fixed";
        textArea.style.left = "-9999px";
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
    };
    $[4] = drop.serial_no;
    $[5] = drop.wave;
    $[6] = isTemporaryDrop;
    $[7] = longPressTriggered;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const copyToClipboard = t6;
  let t7;
  if ($[9] !== activeProfileProxy || $[10] !== connectedProfile?.handle || $[11] !== drop.author.handle) {
    t7 = () => connectedProfile?.handle === drop.author.handle && !activeProfileProxy;
    $[9] = activeProfileProxy;
    $[10] = connectedProfile?.handle;
    $[11] = drop.author.handle;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const getIsAuthor = t7;
  const [isAuthor, setIsAuthor] = useState(getIsAuthor());
  let t8;
  if ($[13] !== getIsAuthor) {
    t8 = () => setIsAuthor(getIsAuthor());
    $[13] = getIsAuthor;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== connectedProfile) {
    t9 = [connectedProfile];
    $[15] = connectedProfile;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  useEffect(t8, t9);
  let t10;
  if ($[17] !== activeProfileProxy || $[18] !== connectedProfile || $[19] !== drop.author.handle || $[20] !== drop.id) {
    t10 = () => {
      if (!connectedProfile?.handle) {
        return false;
      }
      if (activeProfileProxy) {
        return false;
      }
      if (drop.id.startsWith("temp-")) {
        return false;
      }
      return connectedProfile.handle === drop.author.handle;
    };
    $[17] = activeProfileProxy;
    $[18] = connectedProfile;
    $[19] = drop.author.handle;
    $[20] = drop.id;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const getShowOptions = t10;
  const [showOptions, setShowOptions] = useState(getShowOptions());
  let t11;
  if ($[22] !== getShowOptions) {
    t11 = () => setShowOptions(getShowOptions());
    $[22] = getShowOptions;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== activeProfileProxy || $[25] !== connectedProfile) {
    t12 = [connectedProfile, activeProfileProxy];
    $[24] = activeProfileProxy;
    $[25] = connectedProfile;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  useEffect(t11, t12);
  let t13;
  if ($[27] !== setOpen) {
    t13 = () => setOpen(false);
    $[27] = setOpen;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  const closeMenu = t13;
  const t14 = `tw-grid tw-grid-cols-1 tw-gap-y-2 ${longPressTriggered && "tw-select-none"}`;
  let t15;
  if ($[29] !== extendedDrop || $[30] !== onAddReaction) {
    t15 = <WaveDropActionsAddReaction drop={extendedDrop} isMobile={true} onAddReaction={onAddReaction} />;
    $[29] = extendedDrop;
    $[30] = onAddReaction;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== isTemporaryDrop || $[33] !== onQuote || $[34] !== onReply || $[35] !== setOpen || $[36] !== showReplyAndQuote) {
    t16 = showReplyAndQuote && <><button className={`tw-border-0 tw-flex tw-items-center tw-gap-x-4 tw-p-4 tw-bg-iron-950 tw-rounded-xl ${isTemporaryDrop ? "tw-opacity-50 tw-cursor-default" : "active:tw-bg-iron-800"} tw-transition-colors tw-duration-200`} onClick={() => {
        setOpen(false);
        setTimeout(() => onReply(), 250);
      }} disabled={isTemporaryDrop}><svg className="tw-flex-shrink-0 tw-w-5 tw-h-5 tw-text-iron-300" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M7.49 12L3.74 8.248m0 0l3.75-3.75m-3.75 3.75h16.5V19.5" /></svg><span className="tw-text-iron-300 tw-font-semibold tw-text-base">Reply</span></button><button className={`tw-border-0 tw-flex tw-items-center tw-gap-x-4 tw-p-4 tw-bg-iron-950 tw-rounded-xl ${isTemporaryDrop ? "tw-opacity-50 tw-cursor-default" : "active:tw-bg-iron-800"} tw-transition-colors tw-duration-200`} onClick={() => {
        setOpen(false);
        setTimeout(() => onQuote(), 250);
      }} disabled={isTemporaryDrop}><svg className="tw-flex-shrink-0 tw-w-5 tw-h-5 tw-text-iron-300" viewBox="0 0 24 24" aria-hidden="true" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.9486 14.4306C4.45605 15.6736 3.67749 16.904 2.63489 18.0883C2.3031 18.4652 2.26098 19.0031 2.53015 19.4268C2.73742 19.7528 3.08606 19.9384 3.4552 19.9384C3.5592 19.9384 3.66504 19.9238 3.76941 19.8934C5.97913 19.2478 11.1335 16.9546 11.272 9.62448C11.3254 6.79404 9.25526 4.3624 6.55958 4.08847C5.07385 3.93978 3.5874 4.42245 2.48584 5.41818C1.38281 6.41501 0.75 7.8381 0.75 9.32309C0.75 11.8005 2.50854 13.967 4.9486 14.4306ZM3.49145 6.53109C4.19201 5.89791 5.07385 5.56063 6.00879 5.56063C6.14099 5.56063 6.27429 5.56722 6.40796 5.58114C8.33313 5.77632 9.8108 7.54 9.77198 9.59591C9.6764 14.6679 6.93018 16.9513 4.65601 17.9726C5.37561 16.9992 5.94104 15.998 6.34314 14.9832C6.49988 14.5881 6.47388 14.1465 6.27209 13.7715C6.06079 13.3781 5.68396 13.0991 5.23901 13.0057C3.50683 12.6435 2.25 11.0944 2.25 9.32308C2.25 8.26181 2.70263 7.24411 3.49145 6.53109Z" fill="currentColor" /><path d="M14.508 19.4271C14.7153 19.753 15.064 19.9387 15.4331 19.9387C15.5371 19.9387 15.6426 19.924 15.7473 19.8936C17.957 19.248 23.1111 16.9548 23.2495 9.62472C23.3022 6.79427 21.2324 4.36263 18.5364 4.08871C17.0488 3.93746 15.5649 4.42232 14.4634 5.41842C13.3604 6.41525 12.7275 7.83834 12.7275 9.32333C12.7275 11.8007 14.4861 13.9672 16.9258 14.4309C16.4329 15.6749 15.6543 16.9054 14.6121 18.089C14.2803 18.4661 14.2385 19.0037 14.508 19.4271ZM18.3203 14.9842C18.477 14.5891 18.4514 14.1474 18.25 13.7724C18.0383 13.3787 17.6618 13.0997 17.2165 13.0059C15.4844 12.6438 14.2275 11.0947 14.2275 9.32333C14.2275 8.26168 14.6802 7.24435 15.469 6.53133C16.1692 5.89815 17.051 5.56087 17.9863 5.56087C18.1181 5.56087 18.2515 5.56746 18.3855 5.58137C20.3103 5.77656 21.7883 7.54024 21.7495 9.59615C21.6543 14.6685 18.9077 16.9515 16.6335 17.9729C17.3528 17.0002 17.9175 15.999 18.3203 14.9842Z" fill="currentColor" /></svg><span className="tw-text-iron-300 tw-font-semibold tw-text-base">Quote</span></button></>;
    $[32] = isTemporaryDrop;
    $[33] = onQuote;
    $[34] = onReply;
    $[35] = setOpen;
    $[36] = showReplyAndQuote;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== closeMenu || $[39] !== drop || $[40] !== showOpenOption) {
    t17 = showOpenOption && <WaveDropMobileMenuOpen drop={{
      type: DropSize.FULL,
      ...drop,
      stableHash: drop.id,
      stableKey: drop.id
    }} onOpenChange={closeMenu} />;
    $[38] = closeMenu;
    $[39] = drop;
    $[40] = showOpenOption;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== copied || $[43] !== copyToClipboard || $[44] !== isTemporaryDrop || $[45] !== showCopyOption) {
    t18 = showCopyOption && <button className={`tw-border-0 tw-flex tw-items-center tw-gap-x-4 tw-p-4 tw-bg-iron-950 tw-rounded-xl ${isTemporaryDrop ? "tw-opacity-50 tw-cursor-default" : "active:tw-bg-iron-800"} tw-transition-colors tw-duration-200`} onClick={copyToClipboard} disabled={isTemporaryDrop}><svg className="tw-flex-shrink-0 tw-w-5 tw-h-5 tw-text-iron-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" /></svg><span className={`tw-font-semibold tw-text-base ${copied ? "tw-text-primary-400" : "tw-text-iron-300"}`}>{copied ? "Copied!" : "Copy link"}</span></button>;
    $[42] = copied;
    $[43] = copyToClipboard;
    $[44] = isTemporaryDrop;
    $[45] = showCopyOption;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== closeMenu || $[48] !== drop || $[49] !== isAuthor || $[50] !== showFollowOption) {
    t19 = showFollowOption && !isAuthor && <WaveDropMobileMenuFollow drop={drop} onFollowChange={closeMenu} />;
    $[47] = closeMenu;
    $[48] = drop;
    $[49] = isAuthor;
    $[50] = showFollowOption;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  let t20;
  if ($[52] !== closeMenu || $[53] !== drop || $[54] !== isAuthor) {
    t20 = !isAuthor && <WaveDropActionsRate drop={drop} isMobile={true} onRated={closeMenu} />;
    $[52] = closeMenu;
    $[53] = drop;
    $[54] = isAuthor;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] !== closeMenu || $[57] !== drop || $[58] !== onEdit || $[59] !== showOptions) {
    t21 = showOptions && onEdit && drop.drop_type !== ApiDropType.Participatory && <WaveDropMobileMenuEdit drop={drop} onEdit={onEdit} onEditTriggered={closeMenu} />;
    $[56] = closeMenu;
    $[57] = drop;
    $[58] = onEdit;
    $[59] = showOptions;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  let t22;
  if ($[61] !== closeMenu || $[62] !== drop || $[63] !== showOptions) {
    t22 = showOptions && <WaveDropMobileMenuDelete drop={drop} onDropDeleted={closeMenu} />;
    $[61] = closeMenu;
    $[62] = drop;
    $[63] = showOptions;
    $[64] = t22;
  } else {
    t22 = $[64];
  }
  let t23;
  if ($[65] !== t14 || $[66] !== t15 || $[67] !== t16 || $[68] !== t17 || $[69] !== t18 || $[70] !== t19 || $[71] !== t20 || $[72] !== t21 || $[73] !== t22) {
    t23 = <div className={t14}>{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}</div>;
    $[65] = t14;
    $[66] = t15;
    $[67] = t16;
    $[68] = t17;
    $[69] = t18;
    $[70] = t19;
    $[71] = t20;
    $[72] = t21;
    $[73] = t22;
    $[74] = t23;
  } else {
    t23 = $[74];
  }
  let t24;
  if ($[75] !== isOpen || $[76] !== setOpen || $[77] !== t23) {
    t24 = createPortal(<CommonDropdownItemsMobileWrapper isOpen={isOpen} setOpen={setOpen}>{t23}</CommonDropdownItemsMobileWrapper>, document.body);
    $[75] = isOpen;
    $[76] = setOpen;
    $[77] = t23;
    $[78] = t24;
  } else {
    t24 = $[78];
  }
  return t24;
};
export default WaveDropMobileMenu;